/**
 * Sistema de auto-actualización para producción
 * Detecta nuevas versiones y notifica al usuario
 */

const CHECK_INTERVAL = 60000; // Revisar cada 60 segundos
let currentVersion = null;
let updateAvailable = false;

// Función para mostrar notificación de actualización
function showUpdateNotification() {
  // Evitar mostrar múltiples veces
  if (updateAvailable) return;
  updateAvailable = true;

  // Crear el elemento de notificación
  const notification = document.createElement('div');
  notification.id = 'update-notification';
  notification.innerHTML = `
    <style>
      #update-notification {
        position: fixed;
        top: 20px;
        right: 20px;
        background: white;
        border: 2px solid #000;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
        z-index: 999999;
        font-family: 'Space Grotesk', sans-serif;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      }

      @keyframes slideIn {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }

      #update-notification h3 {
        margin: 0 0 10px 0;
        color: #000;
        font-size: 18px;
      }

      #update-notification p {
        margin: 0 0 15px 0;
        color: #666;
        font-size: 14px;
      }

      #update-notification button {
        background: #c4fffc;
        color: #000;
        border: 2px solid #000;
        padding: 10px 20px;
        border-radius: 8px;
        font-weight: 600;
        cursor: pointer;
        margin-right: 10px;
        font-family: 'Space Grotesk', sans-serif;
      }

      #update-notification button:hover {
        background: #000;
        color: #c4fffc;
      }

      #update-notification .dismiss {
        background: transparent;
        border: 2px solid #666;
        color: #666;
      }

      #update-notification .dismiss:hover {
        background: #f0f0f0;
      }
    </style>
    <h3>🚀 Nueva versión disponible</h3>
    <p>Hay una actualización de Paper Boat disponible con mejoras y correcciones.</p>
    <button onclick="window.location.reload(true)">Actualizar ahora</button>
    <button class="dismiss" onclick="document.getElementById('update-notification').remove()">Más tarde</button>
  `;

  document.body.appendChild(notification);
}

// Función para verificar versión
async function checkForUpdates() {
  try {
    // Agregar timestamp para evitar caché
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    });

    if (!response.ok) {
      console.error('No se pudo verificar actualizaciones');
      return;
    }

    const data = await response.json();

    if (currentVersion === null) {
      // Primera carga - guardar versión actual
      currentVersion = data.timestamp;
      console.log('📌 Versión actual de Paper Boat:', new Date(currentVersion).toLocaleString());
    } else if (currentVersion !== data.timestamp && data.timestamp > currentVersion) {
      // Nueva versión detectada
      console.log('🔄 Nueva versión detectada:', new Date(data.timestamp).toLocaleString());
      showUpdateNotification();
    }
  } catch (error) {
    console.error('Error verificando actualizaciones:', error);
  }
}

// Función principal para iniciar el auto-updater
export function startAutoUpdater() {
  // Solo en producción
  if (import.meta.env.PROD) {
    // Verificar inmediatamente
    checkForUpdates();

    // Verificar periódicamente
    setInterval(checkForUpdates, CHECK_INTERVAL);

    // Verificar cuando la ventana recupera el foco
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        checkForUpdates();
      }
    });

    // Verificar cuando vuelve de estar offline
    window.addEventListener('online', () => {
      setTimeout(checkForUpdates, 3000);
    });

    console.log('✅ Sistema de auto-actualización activado');
  }
}

// Función para limpiar caché viejo (ejecutar en cada inicio)
export function cleanOldCache() {
  // Limpiar service workers viejos
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    });
  }

  // Limpiar caches API si existe
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
}

export default {
  startAutoUpdater,
  cleanOldCache
};